<template>
  <section role="main">
    <form
      class="mt-5 mr-2 ml-2 justify-content-md-center"
      @submit.prevent="next"
    >
      <div class="col">
        <section class="card">
          <header class="card-header">
            <h2 class="card-title"></h2>
          </header>
          <div class="card-body" id="frmBody">
            <div v-if="!isLoading">
              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550"
                    >Please select up to 4 regions that pertain to your
                    visit</label
                  >
                  <multiselect
                    :searchable="false"
                    v-model="form.regions"
                    :options="regionsLocation"
                    :group-select="true"
                    :multiple="true"
                    @select="selectChange"
                    @remove="removeChange"
                    :max="4"
                    placeholder="Click HERE to Add Complaints"
                  >
                    <template slot="selection" slot-scope="{ values }">
                      <div v-if="values.length > 0"  class="multiselect__tags" style="margin-bottom: 10px;">
                        <span
                          v-for="(value, index) in values"
                          :key="index"
                          class="multiselect__tag"
                        >
                          <span>{{ value }}</span>
                          <i
                            class="multiselect__tag-icon"
                            @click.stop="removeItem(value)"
                          ></i>
                        </span>
                        <span class="multiselect__placeholder">Click HERE to Add Complaints</span>
                      </div>
                    </template>
                  </multiselect>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550">Primary Complaint</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.complaint1"
                    disabled
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550">2nd Complaint</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.complaint2"
                    disabled
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550">3rd Complaint</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.complaint3"
                    disabled
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-6 mx-auto">
                  <label class="label f-weight-550">4th Complaint</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.complaint4"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div v-if="isLoading">
              <div class="col-12">
                <content-placeholders :rounded="true" :centered="true">
                  <content-placeholders-text :lines="5" />
                </content-placeholders>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <div class="row justify-content-end">
              <div class="col-sm-9">
                <button
                  type="reset"
                  class="btn btn-default mr-2"
                  @click="previous"
                  v-if="getTaskPreviousTaskType"
                >
                  Back
                </button>
                <btn-saving :is-saving="isSaving" />
              </div>
            </div>
          </footer>
        </section>
      </div>
    </form>
  </section>
</template>

<script>
import Multiselect from 'vue-multiselect'
import '../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css'
import api from '../../api/http-common.js'
import { mapGetters, mapActions } from 'vuex'
import btnSaving from '../button-saving.vue'
export default {
  components: {
    Multiselect,
    btnSaving
  },
  data() {
    return {
      isLoading: true,
      isSaving: false,
      form: {
        regions: [],
        complaint1: '',
        complaint2: '',
        complaint3: '',
        complaint4: ''
      },
      problems: [],
      forDelete: null
    }
  },
  watch: {
    'form.regions': function () {
      // added by Rizza 04/02/2022
      this.problems = []
      this.form.complaint1 = ''
      this.form.complaint2 = ''
      this.form.complaint3 = ''
      this.form.complaint4 = ''

      for (var i = 0; i < this.form.regions.length; i++) {
        const region = this.form.regions[i]
        const ctr = i + 1
        const name = 'complaint' + ctr
        this.form[name] = region

        this.problems.push({
          id: 0,
          ordinal: ctr,
          region: region
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'getProfilePatientAssociated',
      'getTaskCurrentCaseHistoryId',
      'getTaskPreviousTaskType',
      'getTaskCurrentTaskType',
      'currentPatientAssociated'
    ]),
    regionsLocation() {
      return [
        'Neck',
        'Lower Back',
        'Mid Back',
        'Head',
        'Jaw',
        'Shoulder',
        'Arm',
        'Elbow',
        'Wrist',
        'Hand',
        'Upper Back',
        'Hip',
        'Leg',
        'Knee',
        'Ankle',
        'Foot'
      ]
    }
  },
  methods: {
    ...mapActions([
      'setTaskCurrentCaseHistoryProblems',
      'setTaskCurrentTaskType',
      'setTaskCurrentCaseHistoryOats',
      'setTaskCurrentTaskTypeRemove'
    ]),
    selectChange(selected) {
      // Clear all complaint fields and rebuild based on current regions
      this.form.complaint1 = ''
      this.form.complaint2 = ''
      this.form.complaint3 = ''
      this.form.complaint4 = ''

      // Rebuild problems array and complaint fields based on current regions
      this.problems = []
      for (let i = 0; i < this.form.regions.length; i++) {
        const region = this.form.regions[i]
        const ctr = i + 1
        const name = 'complaint' + ctr
        this.form[name] = region

        this.problems.push({
          id: 0,
          ordinal: ctr,
          region: region
        })
      }
    },
    removeChange(removed) {
      // Clear all complaint fields and rebuild based on current regions
      this.form.complaint1 = ''
      this.form.complaint2 = ''
      this.form.complaint3 = ''
      this.form.complaint4 = ''

      // Rebuild problems array and complaint fields based on remaining regions
      this.problems = []
      for (let i = 0; i < this.form.regions.length; i++) {
        const region = this.form.regions[i]
        const ctr = i + 1
        const name = 'complaint' + ctr
        this.form[name] = region

        this.problems.push({
          id: 0,
          ordinal: ctr,
          region: region
        })
      }
    },
    removeItem(value) {
      // Remove the item from the regions array
      const index = this.form.regions.indexOf(value)
      if (index > -1) {
        this.form.regions.splice(index, 1)
      }

      // Clear all complaint fields and rebuild based on current regions
      this.form.complaint1 = ''
      this.form.complaint2 = ''
      this.form.complaint3 = ''
      this.form.complaint4 = ''

      // Rebuild problems array and complaint fields based on remaining regions
      this.problems = []
      for (let i = 0; i < this.form.regions.length; i++) {
        const region = this.form.regions[i]
        const ctr = i + 1
        const name = 'complaint' + ctr
        this.form[name] = region

        this.problems.push({
          id: 0,
          ordinal: ctr,
          region: region
        })
      }
    },
    async next() {
      if (this.form.regions.length === 0) {
        this.$swal({
          text: 'Please select a region that pertains to your visit.',
          position: 'top-center',
          title: 'Error',
          showConfirmButton: false,
          timerProgressBar: true,
          timer: 2000,
          icon: 'error'
        })
        return
      }
      this.isSaving = true
      if (this.forDelete.length > 0) {
        for await (const result of this.forDelete) {
          await api.task.request.deleteCaseHistoryProblem({
            facilityId: this.currentPatientAssociated.facilityID,
            caseHistoryProblemId: result.id
          })
        }
      }

      const promMultipleInsert = new Promise((resolve, reject) => {
        this.problems.forEach(async (el, index, arr) => {
          await api.task.request.insertCaseHistoryProblem({
            facilityId: this.currentPatientAssociated.facilityID,
            caseHistoryId: this.getTaskCurrentCaseHistoryId,
            ordinal: el.ordinal,
            region: el.region,
            name: ''
          })
          console.log('insertCaseHistoryProblem')
          console.log(arr)
          if (index === arr.length - 1) {
            resolve()
          }
        })
      })

      await promMultipleInsert

      const problems = await api.task.request.getCaseHistoryProblems({
        facilityId: this.currentPatientAssociated.facilityID,
        caseHistoryId: this.getTaskCurrentCaseHistoryId
      })

      const oats = await api.task.request.getCaseHistoryOats({
        facilityId: this.currentPatientAssociated.facilityID,
        caseHistoryId: this.getTaskCurrentCaseHistoryId
      })
      await this.setTaskCurrentCaseHistoryOats(oats.data)
      await this.setTaskCurrentCaseHistoryProblems(problems.data)
      this.isSaving = false
      await this.setTaskCurrentTaskType('NphComplaintQuestions')
    },
    async previous() {
      const currentIndex = this.getTaskPreviousTaskType.findIndex(
        (c) => c === this.getTaskCurrentTaskType
      )
      let prevPage = ''
      if (currentIndex === -1) {
        prevPage =
          this.getTaskPreviousTaskType[this.getTaskPreviousTaskType.length - 1]
      } else {
        prevPage = this.getTaskPreviousTaskType[currentIndex - 1]
      }

      this.setTaskCurrentTaskType({
        back: true,
        page: prevPage,
        removePage: this.getTaskCurrentTaskType
      })
    }
  },
  async mounted() {},
  async activated() {
    this.form = {
      regions: [],
      complaint1: '',
      complaint2: '',
      complaint3: '',
      complaint4: ''
    }

    // console.log('activated!')
    this.isLoading = true
    const result = await api.task.request.getCaseHistoryProblems({
      facilityId: this.currentPatientAssociated.facilityID,
      caseHistoryId: this.getTaskCurrentCaseHistoryId
    })
    this.form.regions = []
    this.forDelete = result.data
    // console.log('this.form.regions>', this.form.regions)
    // console.log('this.forDelete>', this.forDelete)
    if (this.forDelete.length > 0) {
      this.forDelete.forEach((el) => {
        // console.log('pushing this.form.regions>el.region', el.region)
        this.form.regions.push(el.region)
        switch (el.ordinal) {
          case 1:
            this.form.complaint1 = el.region
            break
          case 2:
            this.form.complaint2 = el.region
            break
          case 3:
            this.form.complaint3 = el.region
            break
          case 4:
            this.form.complaint4 = el.region
            break
        }
      })
    }
    this.isLoading = false

    setTimeout(() => {
      const el = document.getElementById('frmBody')
      el.scrollIntoView({ behavior: 'smooth' })
      // console.log('should be scrolling to top!')
    }, 1000)
  }
}
</script>

<style scoped>
.multiselect__placeholder {
  text-align: center;
  width: 100%;
  display: block;
  line-height: 40px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.multiselect__tags {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  min-height: 40px;
  position: relative;
}

.multiselect__tags .multiselect__placeholder {
  display: inline-block;
  text-align: left;
  line-height: 1.5;
  margin: 0;
  padding: 0;
  vertical-align: middle;
  position: static;
  transform: none;
  pointer-events: auto;
  white-space: nowrap;
  font-weight: 600;
}

.multiselect__tag {
  margin: 0 4px 0 0;
  flex-shrink: 0;
}
</style>
